<div class="grid grid-cols-2 md:grid-cols-1 border-t-1 border-gray-200">
  <app-card class="px-4 py-2 border-b mb:border-r border-gray-200 leading-6" title="Details Produktion:"
            routerLink="/energy-chart">
    @if (status()?.productionStatus) {
      <span class="status-name">Gesamt:</span>
      <span class="text-end">{{ status()?.productionStatus?.total | number:'1.2-2' }}</span>
      <span class="text-end"> kW</span>
      <span></span>
      @for (production of status()?.productionStatus?.values || []; track production.id; let index = $index) {
        <span class="status-name">{{ production.name }}:</span>
        <span class="text-end">{{ production.value | number:'1.2-2' }}</span>
        <span class="text-end"> kW</span>
        <span></span>
      }

    }
  </app-card>

  <app-card class="px-4 py-2 border-b border-gray-200 leading-6" title="Details Batterie:"
            routerLink="/energy-chart" fragment="battery">
    @if (status()?.batteryChargeStatus && status()?.calculatedBatteryPowerStatus) {
      <span class="status-name">Gesamt:</span>
      <span class="text-end">{{ status()?.batteryChargeStatus?.total }}</span>
      <span class="text-center"> %</span>
      <span>({{ status()?.calculatedBatteryPowerStatus?.total | number:'1.2-2' }} kWh)</span>
      @for (battery of status()?.batteryChargeStatus?.values || []; track battery.id; let index = $index) {
        <span class="status-name">{{ battery.name }}: </span>
        <span class="text-end">{{ battery.value }}</span>
        <span class="text-center"> %</span>
        <span>({{ status()?.calculatedBatteryPowerStatus?.values?.[index]?.value | number:'1.2-2' }} kWh)</span>
      }
    }
  </app-card>
  <app-card class="px-4 py-2 border-b mb:border-r border-gray-200 leading-6" title="Details Verbrauch:"
            routerLink="/energy-chart" fragment="consumption">
    @if (status()?.consumptionStatus) {
      <span class="status-name">Gesamt:</span>
      <span class="text-end">{{ status()?.consumptionStatus?.total | number:'1.2-2' }}</span>
      <span class="text-end"> kW</span>
      <span></span>
      @for (consumer of status()?.consumptionStatus?.values || []; track consumer.id; let index = $index) {
        <span class="status-name">{{ consumer.name }}: </span>
        <span class="text-end">{{ consumer.value | number:'1.2-2' }}</span>
        <span class="text-end"> kW</span>
        <span></span>
      }
    }
  </app-card>
  <app-card class="px-4 py-2 border-b border-gray-200 leading-6" title="Details Netz:"
            routerLink="/energy-chart" fragment="grid">
    @if (status()?.networkStatus?.values) {
      @for (grid of status()?.networkStatus?.values || []; track grid.id; let index = $index) {
        <!--      <span>{{ grid.name }}</span>-->
        @if (grid.value && grid.value > 0) {
          <span>Bezug:</span>
        } @else {
          <span>Lieferung:</span>
        }
        <span class="text-end">@if (grid.value) {
          {{ Math.abs(grid.value) | number:'1.2-2' }}
        }</span>
        <span class="text-end"> kW</span>
        <span></span>
      }
    }
  </app-card>
</div>
